<gridster *ngIf="!!dashboard.length"
          [options]="options"
          class="pb-20">
  <gridster-item *ngFor="let widget of dashboard"
                 [item]="widget"
                 (itemChange)="widgetComponent.onChange($event)"
                 (itemResize)="widgetComponent.onResize($event)">
    <app-widget #widgetComponent
                [widget]="widget"
                [dashboard]="dashboard"></app-widget>
  </gridster-item>
</gridster>
